import { Routes, Route } from 'react-router-dom'
import WebSite from "./pages/WebSite";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import OurGames from "./pages/OurGames";
import ContactUs from "./pages/ContactUs";
import Layout from "./components/dev/Layout";
import {LinkedIn} from "./pages/LinkedIn";
import MainHome from "./pages/MainHome";

export default function App() {
    return (
        <Routes>
            <Route path="/" element={<MainHome />} />
            <Route path="/game-dev" element={<Layout />}>
                <Route path="home" element={<Home />}  />
                <Route path="about-us" element={<AboutUs />} />
                <Route path="our-games" element={<OurGames />} />      
                <Route path="contact-us" element={<ContactUs />} />
                <Route path="news" element={<LinkedIn />} />
            </Route>
            <Route path="/web" element={<WebSite />} />
        </Routes>

    );
}


